import React from 'react';

export default function NoResults({ children }) {
	return (
		<div className='row no_transactions'>
			<div className='col s12'>
				<h5 className='center-align'>{children}</h5>
			</div>
		</div>
	);
}